import React from 'react'
import './events.css'
import event1 from '../../assets/events/Triathlon.jpeg'
import event2 from '../../assets/events/cosmic_quest.jpeg'
import event3 from '../../assets/events/fake_off.jpeg'
import event4 from '../../assets/events/space_survival.jpeg'
import event5 from '../../assets/events/blogathon.jpeg'
import event6 from '../../assets/events/cygnus.jpeg'

import {FaLongArrowAltRight} from 'react-icons/fa'

const Events = () => {
  return (
    <div>
        {/* <!-- Start Articles --> */}
        <div class="articles" id="articles">
        <h2 class="main-title">Previous Events</h2>
        <div class="container">
            <div class="box">
            <img style={{height:'270px'}} src={event1} alt="" />
            <div class="content">
            <h3 style={{color:'#2196F3'}}>Triathlon</h3>
                <p>'Les Trios Sports' launched a new age in sports, putting competitors to the ultimate test. The contestants were tested in three areas: analytical thinking, reasoning, and problem-solving abilities. It was undoubtedly daunting, but its main aim was to provide participants with a platform to exhibit your endurance, strength, and mental agility.</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CjQkMQ0pAjP/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img style={{height:'270px'}} src={event2} alt="" />
            <div class="content">
            <h3 style={{color:'#2196F3'}}>Cosmic Quest</h3>
                <p>Have you got what it takes to become a renowned treasure hunter?
Well, it is time to test your
skills for Nakshatra - The Astronomy and Mathematics Society of NSUT presents Cosmic
Quest’, our renowned treasure hunt event. The goal is simple, just find the hints and follow
the lead.</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CjNaoIYJ34A/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img style={{height:'270px'}} src={event3} alt="" />
            <div class="content">
                <h3 style={{color:'#2196F3'}}>Fake Off</h3>
                <p>We are often fascinated by intriguing notions.
Thus, Nakshatra NSUT devised this event to put your creative and analytical talents to the test by enabling you to accept or reject a hypothesis based on existing theories/logic.</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CbNufawhl9r/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img style={{height:'270px'}} src={event4} alt="" />
            <div class="content">
            <h3 style={{color:'#2196F3'}}>Space Survival</h3>
                <p>Nakshatra - The Astronomy and Mathematics Club of NSUT brings to you "SPACE SURVIVAL", an event comprising of 3 levels wherein embolden by the flame of ambition, you get to exhibit your survival skills. So, what are you waiting for?</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CbQTaj2hroN/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img style={{height:'270px'}} src={event5} alt="" />
            <div class="content">
            <h3 style={{color:'#2196F3'}}>Blogathon</h3>
                <p>Nakshatra, in conjunction with IOSD-NSUT, had organized an intriguing event called "WHAT IF?" A blogging event that helped to exhibit creative writing abilities! The finest of these articles were published on our NESCII page.</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CZlqPFMldlb/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img style={{height:'270px'}} src={event6} alt="" />
            <div class="content">
            <h3 style={{color:'#2196F3'}}>Cygnus 2022</h3>
                <p>CYGNUS 2022 was the inaugural event held by Nakshatra on January 20, 2022 for the incoming freshers class of 2025 as part of NSUTTHON.</p>
            </div>
            <div class="info">
                <a href="https://www.instagram.com/p/CY3K7U0l7DV/" target="_blank">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            {/* <div class="box">
            <img src={lovkesh} alt="" />
            <div class="content">
                <h3>Test Title</h3>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Reprehenderit</p>
            </div>
            <div class="info">
                <a href="#">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div>
            <div class="box">
            <img src={lovkesh} alt="" />
            <div class="content">
                <h3>Test Title</h3>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Reprehenderit</p>
            </div>
            <div class="info">
                <a href="#">Read More</a>
                <FaLongArrowAltRight className="i" />
            </div>
            </div> */}
        </div>
        </div>
        {/* <div class="spikes"></div> */}
        {/* <!-- End Articles --> */}
    </div>
  )
}

export default Events